import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Projects from "@/pages/Projects";
import ProjectWorkspace from "@/pages/ProjectWorkspace";
import MoodboardEditor from "@/pages/MoodboardEditor";
import SearchPage from "@/pages/SearchPage";
import ComparePage from "@/pages/ComparePage";
import PublicProjectView from "@/pages/PublicProjectView";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AdminPanel from "@/pages/AdminPanel";
import Profile from "@/pages/Profile";
import AcceptInvite from "@/pages/AcceptInvite";
import { ConfirmDialogProvider } from "@/components/ConfirmDialog";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import SubscriptionGate from "@/components/SubscriptionGate";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ConfirmDialogProvider>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/shared/:token" element={<PublicProjectView />} />
              <Route path="/accept-invite" element={<AcceptInvite />} />
              <Route
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route path="/studio" element={<SubscriptionGate><Projects /></SubscriptionGate>} />
                <Route path="/project/:projectId" element={<SubscriptionGate><ProjectWorkspace /></SubscriptionGate>} />
                <Route
                  path="/project/:projectId/moodboard/:moodboardId"
                  element={<SubscriptionGate><MoodboardEditor /></SubscriptionGate>}
                />
                <Route path="/search" element={<SubscriptionGate><SearchPage /></SubscriptionGate>} />
                <Route path="/compare" element={<SubscriptionGate><ComparePage /></SubscriptionGate>} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/admin" element={<AdminPanel />} />
              </Route>
            </Routes>
          </ConfirmDialogProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
